import {
  Cloud,
  CloudDrizzle,
  CloudFog,
  CloudLightning,
  CloudMoon,
  CloudRain,
  CloudSnow,
  CloudSun,
  Moon,
  Sun,
  Wind,
  type LucideIcon,
} from 'lucide-react';

// Pirate Weather (Dark Sky compat) returns a small, stable enum of icon keys.
// Map them directly — no parsing of URLs or ambiguous text required.
const PIRATE_ICON_MAP: Record<string, LucideIcon> = {
  'clear-day': Sun,
  'clear-night': Moon,
  'partly-cloudy-day': CloudSun,
  'partly-cloudy-night': CloudMoon,
  cloudy: Cloud,
  rain: CloudRain,
  snow: CloudSnow,
  sleet: CloudDrizzle,
  fog: CloudFog,
  wind: Wind,
  thunderstorm: CloudLightning,
  hail: CloudSnow,
};

export function iconFromPirateKey(key: string | null | undefined): LucideIcon | null {
  if (!key) return null;
  return PIRATE_ICON_MAP[key] ?? null;
}

export function iconFor(condition: string, isDaytime = true): LucideIcon {
  const c = (condition ?? '').toLowerCase();
  if (c.includes('thunder') || c.includes('storm')) return CloudLightning;
  if (c.includes('snow') || c.includes('flurr') || c.includes('blizzard')) return CloudSnow;
  if (c.includes('drizzle')) return CloudDrizzle;
  if (c.includes('rain') || c.includes('shower')) return CloudRain;
  if (c.includes('fog') || c.includes('haze') || c.includes('mist') || c.includes('smoke')) return CloudFog;
  if (c.includes('wind')) return Wind;
  if (
    c.includes('partly cloudy') ||
    c.includes('mostly sunny') ||
    c.includes('mostly clear') ||
    c.includes('partly sunny')
  )
    return isDaytime ? CloudSun : CloudMoon;
  if (c.includes('cloud') || c.includes('overcast')) return Cloud;
  return isDaytime ? Sun : Moon;
}
